import { Button } from 'reactstrap';
import { ConfirmationModal } from '@g17eco/molecules/confirm-modal';
import { useDeleteSubsidiaryGroupMutation } from '@api/subsidiary-groups';
import { generateToast, toastFromError } from '@g17eco/molecules/toasts';

interface Props {
  initiativeId: string;
  group: { groupId: string; groupName: string } | null;
  onClose: () => void;
}

export const DeleteSubsidiaryGroupModal = ({ initiativeId, group, onClose }: Props) => {
  const [deleteGroup, { isLoading: isDeleting }] = useDeleteSubsidiaryGroupMutation();

  const handleConfirm = async () => {
    if (!group) return;

    try {
      await deleteGroup({ initiativeId, groupId: group.groupId }).unwrap();
      onClose();
      generateToast({
        color: 'success',
        title: 'Success',
        message: 'Subsidiary group deleted successfully',
      });
    } catch (err) {
      toastFromError({ error: err, title: 'Failed to delete group' });
    }
  };

  return (
    <ConfirmationModal
      isOpen={!!group}
      title='Delete Subsidiary Group'
      content={
        <div>
          Are you sure you want to delete <strong>{group?.groupName}</strong>?
          <br />
          This action cannot be undone.
        </div>
      }
      handleCancel={onClose}
      confirmButton={
        <Button color='danger' onClick={handleConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      }
    />
  );
};
